import { t } from "i18next";
import React from "react";
import { useNavigate } from "react-router-dom";
import { ReactComponent as WorkInProgress } from "../../assets/images/layout/Workinprogress.svg";

const Inprogress = () => {
  let navigate = useNavigate();
  return (
    <>
      <div className="unauthWrap">
        <WorkInProgress />
        <p>{t("inprogress.title")}</p>
      </div>
      <div className="subsWrapper">
        <div className="plnaBtn">
          <button onClick={() => navigate("/")}>{t("inprogress.btn")}</button>
        </div>
      </div>
    </>
  );
};

export default Inprogress;
